import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useCallback, useEffect, useState } from 'react';
import { FilterProps } from '@/graphQl/nftList.type';
import { NftFilter, useNftContent } from '@/lib/providers/NftContextProvider';

const StyledRadio = styled(Radio)(({ theme }) => ({
  display: 'none',
  fontFamily: theme?.MojitoClaim?.font?.secondary
}));

const StyledLabel = styled(FormControlLabel)<{ selected: boolean; value: string }>(({ selected, value }) => ({
  flex: 1,
  height: '40px',
  background: selected ? '#1A1A1A' : '#1A1A1A',
  border: selected ? '1px solid #FFFFFF' : '1px solid #40464A',
  borderRadius: selected && value == 'all' ? '4px 0 0 4px' : '0 4px 4px 0',
  opacity: selected ? 1 : 0.5,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'background 0.3s ease, border 0.3s ease, opacity 0.3s ease',
  color: '#fff',
  margin: 0
}));

const CustomRadioGroup: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { setNftFilter, refetchSoldTokens, nftFilter } = useNftContent();

  const [value, setValue] = useState<boolean>(nftFilter?.filter === FilterProps.UNSOLD);

  const handleChange = useCallback(() => {
    if (!value) {
      refetchSoldTokens();
    }
    setValue((prev) => !prev);
    setNftFilter((prev: NftFilter) => {
      return { ...prev, filter: value ? FilterProps.ALL : FilterProps.UNSOLD };
    });
  }, [setNftFilter, refetchSoldTokens, value]);

  useEffect(() => {
    const shouldFilterUnsold = nftFilter?.filter === FilterProps.UNSOLD;

    setValue(shouldFilterUnsold);
  }, [nftFilter?.filter]);

  return (
    <RadioGroup
      value={value ? 'unsold' : 'all'}
      onChange={handleChange}
      row
      sx={{ display: 'flex', width: !isMobile ? '160px' : '100%' }}
    >
      <StyledRadio value="all" id="all" />
      <StyledLabel
        control={<StyledRadio checked={!value} />}
        label={<Typography sx={{ fontFamily: theme?.MojitoClaim?.font.secondary }}>All</Typography>}
        selected={!value}
        value={value ? 'unsold' : 'all'}
      />
      <StyledRadio value="unsold" id="unsold" />
      <StyledLabel
        control={<StyledRadio checked={value} />}
        label={<Typography sx={{ fontFamily: theme?.MojitoClaim?.font.secondary }}>Unsold</Typography>}
        selected={value}
        value={value ? 'unsold' : 'all'}
      />
    </RadioGroup>
  );
};

export default CustomRadioGroup;
